<template>
  <NuxtLinkLocale
    to="/"
    class="logo-link focus:outline-none"
  >
    <img
      width="256"
      class="w-60 mr-0 transition hidden dark:block"
      :src="logo.dark"
      alt="logo"
    >
    <img
      width="256"
      class="w-60 mr-0 transition dark:hidden"
      :src="logo.light"
      alt="logo"
    >
    <!-- <span class="text-gray-600">
      <div class="font-handwritten title text-4xl lg:text-6xl">
        {{ config.site_title }}
      </div>
      <div v-if="config.site_subtitle" class="title text-lg lg:text-xl font-thin pl-2! -mt-1">
        {{ config.site_subtitle }}
      </div>
    </span> -->
  </NuxtLinkLocale>
</template>

<script setup>
const { logo, title, showTitle } = useConfig().value.header
</script>

<style scoped>
/* .title {
  @apply bg-clip-text bg-gradient-to-r from-green-800 group-hover: text-transparent to-teal-600 transition-colors whitespace-nowrap px-2;
} */
.logo-link:hover img {
  transform: perspective(100px) rotateY(10deg);
}
</style>
